import Vue from 'vue';
import Axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import Router from 'vue-router';

class Http extends Vue {
    public router!: Router;
    public baseURL = '/api';
    private axios!: AxiosInstance;

    constructor() {
        super();

        this.baseURL = '/api';

        if (document.location.hostname === 'localhost') {
            this.baseURL = 'https://lk.transpropusk.ru/api';
            // this.baseURL = 'https://lk.propusk-expert.ru/api';
           // this.baseURL = 'https://lk.propusk-gp.ru/api';

        }
        this.axios = Axios.create({
            baseURL: this.baseURL,
            timeout: 60 * 3 * 1000
        });
    }

    public onSystemError(callback: (error: string) => void) {
        this.$on('onSystemError', callback);
    }

    public systemError(error: string) {
        this.$emit('onSystemError', error);
    }

    /**
     * Успешный ответ — это data.results с бэкенда (не весь IRequest).
     */
    public async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            this.request(resolve, reject, url, {}, config);
        });
    }

    public async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            this.request(resolve, reject, url, data, config);
        });
    }

    public setRouter(value: Router) {
        this.router = value;
    }

    public assignToken(post: any) {
        const p = Object.assign({}, post);
        if (localStorage.getItem('token') !== null) {
            p.token = localStorage.getItem('token');
        }
        return p;
    }


    private request(resolve: (value?: any) => void,
                    reject: (error?: any) => void,
                    url: string, post: any, config: AxiosRequestConfig | undefined) {

        this.axios.post(url, this.assignToken(post), config)
            .then((req) => {
                const data = req.data as IRequest;
                if (typeof data !== 'object') {
                    this.systemError('Произошла ошибка при выполнения запроса. Попробуйте ещё раз.');
                    reject(new HttpError({error: 'parsing_error'}));
                    return;
                } else if (!data.error) {
                    resolve(data.results);
                } else {
                    switch (data.error) {

                        case 'token_invalid':
                        case 'auth_invalid':
                            document.location.href = '/login/in';
                            break;
                        case 'parameters_invalid':
                            reject(new HttpError({error: data.error, errors: data.errors}));
                            break;
                        default:
                            reject(new HttpError({error: data.error}));
                            break;
                    }
                }
            })
            .catch((error) => {

                if (error.toString() === 'Error: Network Error') {
                    this.systemError('Проверьте покдлчение к интернету и повторите запрос.');
                    reject(new HttpError({error: 'network_error'}));
                    return;
                }
                this.systemError(error.toString());
                reject(new HttpError({error: 'system_error'}));
            });

    }

}

export default new Http();

export interface IRequest {
    ok: boolean;
    error: string;
    results: any;
    runtime: string;
    errors?: IRequestError[];
}

export interface IRequestError {
    message: string;
    field: string;
}


export class HttpError {
    error: string = '';
    errors: IRequestError[] = [];

    public constructor(init?: Partial<HttpError>) {
        Object.assign(this, init);
    }
}
